import moment from 'moment';

const dateTimeHelpers = {
  today: () => ({
    day: moment().format('dddd'),
    date: moment().format('DD-MM-YYYY'),
    dateTime: moment().endOf('day'),
  }),

  timeDiffInMinutes: (startTime, endTime) => {
    const duration = moment.duration(
      moment(endTime, 'HH:mm a').diff(moment(startTime, 'HH:mm a')),
    );

    return duration.asMinutes();
  },
  days: (startTime, endTime) => endTime.diff(startTime, 'days'),
  formatDate: (date, format = 'DD-MM-YYYY') => {
    if (!date) return null;
    return moment(date).format(format);
  },

  toLongTime: (datetime, timezone = 'Asia/Jakarta') => {
    const time = new Date(datetime);

    return time.toLocaleDateString('en-US', {
      timeZone: timezone,
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
  },
  momentToday: () => moment(new Date()),
  isFutureDate: (date) => moment(date).isAfter(moment()),
  isPastDate: (date) => moment(date).isBefore(moment()),
  dateBeforeMonths: (months) => moment().subtract(months, 'months'),
  nextDate: (date) => moment(date).add(1, 'days'),
  toDate: (datetime, timezone = 'Asia/Jakarta') => {
    const time = new Date(datetime);

    return time.toLocaleDateString('en-US', {
      timeZone: timezone,
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  },
  startMonth: () => moment().startOf('month').format('DD-MM-YYYY'),
  endMonth: () => moment().endOf('month').format('DD-MM-YYYY'),
};

export default dateTimeHelpers;
